export default __webpack_public_path__ + "static/developer_tablet@2x-533c2081fdabb7906ca59ad49f6f6f21.png";